import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import {
  OverlayView,
} from "react-google-maps";
import { stateColor, pausedColor, unusedColor } from "./map-filter-items";
import moment from "moment";

// eslint-disable-next-line react/display-name
const MapMarker = memo((props) => {
  const {
    isSelected,
    item,
    showPositionFromMap
  } = props;
  const [showInfo, setShowInfo] = useState(false);

  let styles = {
    boxShadow: "none",
    zIndex: 10,
  };
  if (isSelected) {
    styles = {
      boxShadow: "0 0 25px 12px #008B00",
      zIndex: 1000
    };
  }

  const style = {
    backgroundColor: stateColor,
  };

  if (item.slotsCount <= 2 || item.powerBanksCount <= 2) {
    style.backgroundColor = pausedColor;
  }
  if (item.lastRentDate <= moment()
    .subtract(1, "day")
    .valueOf()) {
    style.backgroundColor = unusedColor;
  }

  return (
    <OverlayView
      position={{
        lat: item.location.latitude,
        lng: item.location.longitude
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        className="markerBikeBox"
        style={styles}
      >
        <div
          className="markerBike"
          onMouseEnter={() => setShowInfo(true)}
          onClick={() => showPositionFromMap(item)}
          style={style}
        >
          <div>
            {item.powerBanksCount}
            <hr className="mt-0 mb-0" style={{
              height: 1,
              borderTopColor: "#000",
            }}/>
            {item.slotsCount - item.powerBanksCount}
          </div>
          {showInfo && (
            <div
              className="markerBikePopup"
              onMouseLeave={() => setShowInfo(false)}
              style={{ bottom: -40 }}
            >
              <div>QR: {item.qr}</div>
              <div>Admin: {item.adminEmail}</div>
              <div>Free Slots: {item.slotsCount - item.powerBanksCount}/{item.slotsCount}</div>
            </div>
          )}
        </div>
      </div>

    </OverlayView>
  );
});

MapMarker.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired
};

export default MapMarker;



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/map/map-marker.js